import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { TextMessage } from 'projects/qcloud-models/sms/text-message';
import { SmsConfigService } from 'projects/qcloud-rest-client/src/lib/sms-config.service';

@Component({
  selector: 'app-send-test-sms',
  templateUrl: './send-test-sms.component.html',
  styleUrls: ['./send-test-sms.component.css']
})
export class SendTestSmsComponent implements OnInit {

  testSms = new TextMessage();
  formSubmitted = false;

  constructor(private smsService: SmsConfigService, private translate: TranslateService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
  }

  onSubmit() {
    this.formSubmitted = true;
    this.smsService.sendTestSms(this.testSms).subscribe(
      res => {
        this.formSubmitted = false;
        this.translate.get('send-test-sms-success').subscribe((res: string) => {
          this.toastr.success(res);
        });
      },
      err => {
        this.formSubmitted = false;
        this.translate.get('send-test-sms-error').subscribe((error: string) => {
          this.translate.get('repeat').subscribe((res: string) => {
            this.toastr.error(res, error);
          });
        });
      }
    );
  }

}
